/*
  GONE.ARCHIVE (21.10.2026): bramka hasla strony /pages/wholesale (sekcja p-wholesale).
  Oferta lezy w assets/ga-wholesale-offer.json zaszyfrowana (AES-256-GCM, klucz PBKDF2-SHA256 z hasla,
  generator: wholesale/szyfruj.mjs). Haslo nie wystepuje w motywie; zle haslo = blad odszyfrowania.
  Po poprawnym hasle oferta (pelny dokument HTML) trafia do iframe srcdoc - bez kolizji z CSS motywu.
  Haslo zostaje w localStorage przegladarki (na stale na tym urzadzeniu, decyzja Bartka 21.10 q5);
  zle lub nieaktualne haslo (np. po zmianie hasla) jest z niego usuwane przy nieudanym odszyfrowaniu.
*/
(function () {
  var root = document.getElementById('gaWholesale');
  if (!root) return;
  var form = root.querySelector('form');
  var input = root.querySelector('input[type="password"]');
  var error = root.querySelector('.ga-ws-error');
  var button = form.querySelector('button');
  var gate = root.querySelector('.ga-ws-gate');
  var offer = root.querySelector('.ga-ws-offer');
  var frame = offer.querySelector('iframe');
  var KEY = 'ga-wholesale-pass';
  var dataPromise = null;

  function b64(s) {
    var bin = atob(s), out = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }

  function load() {
    if (!dataPromise) {
      dataPromise = fetch(root.dataset.src).then(function (r) {
        if (!r.ok) throw new Error('offer ' + r.status);
        return r.json();
      });
    }
    return dataPromise;
  }

  async function decrypt(pass) {
    var d = await load();
    var base = await crypto.subtle.importKey('raw', new TextEncoder().encode(pass), 'PBKDF2', false, ['deriveKey']);
    var key = await crypto.subtle.deriveKey(
      { name: 'PBKDF2', hash: 'SHA-256', salt: b64(d.salt), iterations: d.iter },
      base, { name: 'AES-GCM', length: 256 }, false, ['decrypt']);
    var plain = await crypto.subtle.decrypt({ name: 'AES-GCM', iv: b64(d.iv) }, key, b64(d.ct));
    if (d.gzip) {
      var stream = new Blob([plain]).stream().pipeThrough(new DecompressionStream('gzip'));
      return await new Response(stream).text();
    }
    return new TextDecoder().decode(plain);
  }

  function fit() {
    var doc = frame.contentDocument;
    if (doc && doc.documentElement) frame.style.height = doc.documentElement.scrollHeight + 'px';
  }

  function show(html) {
    gate.hidden = true;
    offer.hidden = false;
    frame.addEventListener('load', function () {
      fit();
      var doc = frame.contentDocument;
      if (window.ResizeObserver) new ResizeObserver(fit).observe(doc.body);
      doc.querySelectorAll('img').forEach(function (img) { img.addEventListener('load', fit); });
    }, { once: true });
    frame.srcdoc = html;
    root.scrollIntoView({ block: 'start' });
  }

  var unsupported = root.querySelector('.ga-ws-unsupported');
  var supported = !!(window.crypto && crypto.subtle && window.DecompressionStream);

  async function unlock(pass, silent) {
    error.hidden = true;
    if (!supported) {
      // bez WebCrypto lub DecompressionStream odszyfrowanie zawsze by padlo - nie pokazujemy wtedy "zle haslo"
      unsupported.hidden = false;
      return;
    }
    button.disabled = true;
    try {
      var html = await decrypt(pass);
      try { localStorage.setItem(KEY, pass); } catch (e) {}
      show(html);
    } catch (e) {
      // OperationError = WebCrypto nie odszyfrowal (zle lub nieaktualne haslo); blad sieci nie kasuje zapisanego hasla
      if (e && e.name === 'OperationError') {
        try { localStorage.removeItem(KEY); } catch (e2) {}
      }
      if (!silent) {
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.select();
      }
    } finally {
      button.disabled = false;
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (input.value.trim()) unlock(input.value.trim(), false);
  });
  input.addEventListener('input', function () {
    error.hidden = true;
    input.removeAttribute('aria-invalid');
  });

  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  if (saved) unlock(saved, true);
})();
